import { HttpErrorResponse } from "@angular/common/http";
import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ManutencaoCTEService } from "src/app/services/gestao-de-cte/gestao-de-cte.service";

@Component({
  selector: "app-modal-recalculo",
  templateUrl: "./modal-recalculo.component.html",
  styleUrls: ["./modal-recalculo.component.scss"],
})
export class ModalRecalculoComponent implements OnInit {
  infoRecalculo: any;
  listaTipoPesagem;

  public tpAcao = [
    { id: 1, descricao: "Revisão por peso aferido" },
    { id: 2, descricao: "Revisão por tabela de preço" },
  ];

  public formFilter = new FormGroup({
    tipoRecalculoId: new FormControl("", Validators.required),
    tipoPesagemId: new FormControl(""),
    dataRef_TabPreco: new FormControl(""),
    tabelaAtiva: new FormControl(true),
    percentualDesconto: new FormControl(0),
  });

  get tipoRecalculoId() {
    return this.formFilter.get("tipoRecalculoId").value;
  }
  get tipoPesagemId() {
    return this.formFilter.get("tipoPesagemId").value;
  }
  get dataRef_TabPreco() { return this.formFilter.get("dataRef_TabPreco").value; }
  get tabelaAtiva() {
    return this.formFilter.get("tabelaAtiva").value;
  }
  get percentualDesconto() {
    return this.formFilter.get("percentualDesconto").value;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public service: ManutencaoCTEService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalRecalculoComponent>
  ) {
    data ? (this.infoRecalculo = data) : (this.infoRecalculo = null);
  }

  ngOnInit() {
    this.consultarTipoPesagem();
  }

  public async consultarTipoPesagem() {
    return this.service
      .consultaTipoPeso()
      .toPromise()
      .then(
        (response: any) => {
          this.listaTipoPesagem = response;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar(
            "Erro ao carregar tipos de pesos, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  acaoRecalculoFrete() {
    const date = new Date(this.dataRef_TabPreco);
    const obj = {
      identificador: this.infoRecalculo.identificador,
      bSobrepor: this.infoRecalculo.bSobrepor,
      identificacaoId: this.infoRecalculo?.identificacaoId,
      tipoRecalculoId: this.tipoRecalculoId,
      origemPesoId: this.tipoPesagemId,
      percentualDesconto: this.percentualDesconto,
      dataRef_TabPreco: this.tabelaAtiva ? null : date.toISOString().split("T")[0],
    };
    this.service.preLoteRecalcularFrete(obj).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.openSnackBar(
            `Recálculo agendado, aguarde...`,
            "OK",
            5000,
            "success-snackbar"
          );
          this.dialogRef.close(1);
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar(`Erro ao carregar.`, "OK", 5000, "danger-snackbar");
      }
    );
  }

  openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
